// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://xvvneliwnontgvctsdsr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh2dm5lbGl3bm9udGd2Y3RzZHNyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA5MDAyMTAsImV4cCI6MjA4NjQ3NjIxMH0.0P2xccs9n-CdFgGQLxDYKpNao3krqj5I4ctyRuLMm1s";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});